import Vue from 'vue';
import Router from 'vue-router';
import HomePage from './components/home.vue'; 
import SubscribeLinks from './components/SubscribeLinks.vue';
import SoftwareDownload from './components/SoftwareDownload.vue';
import UserManager from './components/UserManager.vue';
import NodeHealth from './components/NodeHealth.vue';
import RuleSetManager from './components/RuleSetManager.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/links',
    name: 'SubscribeLinks',
    component: SubscribeLinks
  },
  {
    path: '/download',
    name: 'SoftwareDownload',
    component: SoftwareDownload
  },
  {
    path: '/health',
    name: 'NodeHealth',
    component: NodeHealth
  },
  {
    path: '/admin',
    name: 'UserManager',
    component: UserManager
  },
  {
    path: '/admin/rules',
    name: 'RuleSetManager',
    component: RuleSetManager
  }
];

const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式
  routes
});

export default router;
